import React from 'react';
import {
  ContainerBox,
  Label,
  Value,
} from './CashflowSummaryItem.style-elements';

export interface CashflowSummaryItemProps {
  label: string;
  value: string;
}

const CashflowSummaryItem: React.FC<CashflowSummaryItemProps> = ({
  label,
  value,
}) => {
  return (
    <ContainerBox>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </ContainerBox>
  );
};

export default CashflowSummaryItem;
